import {
  // ShopSelectionWidget,
  UserSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  shop_ids: {
    // 'ui:widget': ShopSelectionWidget,
    "ui:options": {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  user_id: {
    "ui:widget": UserSelectionWidget,
    "ui:options": {
      initFilter: {
        role_id: "6",
      },
    },
  },
});

export default uiSchema;
